export default __webpack_public_path__ + "static/Earth-Day-Collection-Banner-Mobile-e8e0bf06c77e465b9cdc0cf30fb22588.webp";